import { safeDefine } from "../../registration/safe-define.js";
import { BackgroundVideoPlayerElement } from "../../presets/background/player.js";
//#region src/define/background/player.ts
safeDefine(BackgroundVideoPlayerElement);
//#endregion
